<template>
    <div>
        <el-alert
            v-if='warningText'
            style='margin-top: .5rem;margin-bottom: .5rem;'
            :title='warningText'
            :type='warningType'
            :closable='false'>
        </el-alert>
        <el-table :data='dynamicTableFormList'
                  style='width: 100%'>
            <el-table-column width='150px' label='参数名'>
                <template slot-scope='scope'>
                    <el-input size='mini' @blur='handleValueChange' v-model='scope.row.name' :placeholder='`请输入参数名`' />
                </template>
            </el-table-column>
            <el-table-column label='参数类型'>
                <template slot-scope='scope'>
                    <el-select size='mini' v-model="scope.row.type" filterable placeholder="请选择参数类型">
                        <el-option
                            v-for="item in trackParameterTypeOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column width='200px' label='参数描述'>
                <template slot-scope='scope'>
                    <el-input type='textarea' :autosize='{ minRows: 1, maxRows: 2 }' rows='2'
                              size='mini' @blur='handleValueChange' v-model='scope.row.description' :placeholder='`请输入参数描述`' />
                </template>
            </el-table-column>
            <el-table-column
                label='操作'
                width='160px'>
                <template slot-scope='scope' slot='header'>
                    <template>
                        <slot name='table-header'></slot>
                    </template>
                    <el-button type='text' @click='addEmptyDynamicForm' size='mini' >增加一项</el-button>
                </template>
                <template slot-scope='scope'>
                    <el-button
                        @click.native.prevent='removeDynamicForm(scope.$index)'
                        type='text'
                        size='small'>
                        移除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { message } from '@/utils/message';
import { judgeObject, mergeMultiObject } from '@/utils/object';

export default defineComponent({
    name: 'TrackParameterDynamicForm',
    data() {
        return {
            dynamicTableFormList: [],
            generateObject: {},
            generateObjectList: [],
            watchStatus: false,
            inputJsonContent: '',
            open: false,
            
            trackParameterTypeOption: [
                {
                    label: '字符串',
                    value: 'STRING'
                },
                {
                    label: '数值',
                    value: 'INTEGER'
                }
            ]
        }
    },
    props: {
        warningText: String,
        warningType: String,
        showJsonParseButton: true,
        parameterList: [],
    },
    emits: ['getDynamicJsonObject', 'getDynamicJsonString', 'handleRemove'],
    methods: {
        cancel() {
            this.open = false
        },
        addEmptyDynamicForm() {
            this.dynamicTableFormList.push({
                name: '',
                type: '',
                description: '',
                createTime: new Date().getTime()
            });
        },
        addJsonParse() {
            this.open = true
        },
        async handleParse() {
            if (!this.inputJsonContent) {
                message.warning("请输入json内容")
            }
            await this.convertDynamicForm()
            // 将输入的json转换为对象
            let inputObject;
            try {
                inputObject = JSON.parse(this.inputJsonContent);
            } catch (e) {
                message.warning("json内容格式错误")
                return
            }
            let mergedObj = await mergeMultiObject(this.generateObject, inputObject)
            this.dynamicTableFormList = []
            this.generateObject = {}
            await this.handleConvert(JSON.stringify(mergedObj, null, 2))
            await this.handleValueChange()
            this.open = false
            message.success("解析成功")
        },
        removeDynamicForm(index) {
            this.dynamicTableFormList.splice(index, 1);
            this.handleValueChange()
            this.$emit('handleRemove', this.dynamicTableFormList[index])
        },
        handleObjectToTableList() {
            this.dynamicTableFormList = []
            this.generateObject = {}
            if (!this.jsonObject || !this.jsonKey || !this.jsonObject[this.jsonKey]) {
                return
            }
            // let obj = JSON.parse(this.jsonObject[this.jsonKey])
            this.handleConvert(this.jsonObject[this.jsonKey])
        },
        async handleConvert(jsonStr) {
            let jsonObject = JSON.parse(jsonStr)
            for (let key in jsonObject) {
                if (judgeObject(jsonObject[key])) {
                    this.dynamicTableFormList.push({
                        key: key,
                        value: JSON.stringify(jsonObject[key], null, 2)
                    });
                }else {
                    this.dynamicTableFormList.push({
                        key: key,
                        value: jsonObject[key]
                    });
                }
            }
        },
        async convertDynamicForm() {
            let keySet = new Set();
            this.dynamicTableFormList.map(copy => {
                return copy.name;
            }).forEach(key => {
                keySet.add(key);
            });
            if (keySet.size < this.dynamicTableFormList.length) {
                message.warning('表单中存在重复key');
                throw "表单中存在重复key"
            }
        },
        async handleValueChange() {
            try {
                await this.convertDynamicForm()
                this.$emit("getDynamicJsonObject", this.dynamicTableFormList)
                this.$emit("getDynamicJsonString", JSON.stringify(this.dynamicTableFormList))
            }catch (e) {}
        }
    },
    mounted() {
        if (!this.watchStatus && this.jsonObject) {
            this.handleObjectToTableList()
        }
    },
    watch: {
        jsonObject: {
            deep: true,
            handler: function() {
                this.watchStatus = true
                this.handleObjectToTableList()
            }
        }
    }
});
</script>